export enum OhsMyHubTitleTypes {
  MyHubTitle = 'My Hub',
  MyCommunicationTitle = 'My Communication',
  MyTrainingTitle = 'My Training',
}

export interface OhsAdminModuleOptions {
  allowActiveCorrespondenceExchangeView: boolean;
  allowActiveTrainingView: boolean;
}

export interface OhsMyCommunicationCustomFilters {
  archived?: boolean;
  next?: string;
  dateExchange?: { start: string; end: string };
}

export interface OhsMyCommunicationFilterPayload extends OhsMyCommunicationCustomFilters {
  viewPreset?: 'view_1' | 'view_2';
  page: number;
  sort: {
    order: number;
    key: string;
  };
  status?: string[];
  count: boolean;
}

export type MyCommStatus = 'SENT' | 'VIEWED' | 'CLOSED';
export const myCommMappedStatus: Record<MyCommStatus, string> = {
  SENT: 'New',
  VIEWED: 'Viewed',
  CLOSED: 'Closed',
};

export interface CommunicationTokenResult {
  token: string;
}
